import { createSlice } from "@reduxjs/toolkit";
import { getBookingByUrl ,updateExternalUser } from "./InscriptionConferenceThunks";

const initialState = { 
   conference: null, 
    loading: false,
    error: null ,
    conferenceLink:null,
};

const InscriptionConferenceSlice = createSlice({
    name: "InscriptionConference",
    initialState,
    reducers: {
    },
 extraReducers: (builder) => {
        builder
            .addCase(getBookingByUrl.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBookingByUrl.fulfilled, (state, action) => {
                state.loading = false;
                state.conference = action.payload; 
                state.conferenceLink = action.payload.registration_link;
            })
            .addCase(getBookingByUrl.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
             .addCase(updateExternalUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateExternalUser.fulfilled, (state, action) => {
                state.loading = false;
                state.conferenceLink = action.payload.registration_link;
               
            })
            .addCase(updateExternalUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { 
   
} = InscriptionConferenceSlice.actions;

export default InscriptionConferenceSlice.reducer;